import React, { useState } from 'react'
import { PromoMaterialDto } from 'api/ClientArea/PromoMaterialDto'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientAreaApiClient } from 'utils/api/clientAreaApi'
import { useCallbackWithForceRefresh } from 'utils/api/useCallbackWithForceRefresh'
import { useFetchOne } from 'utils/api/useFetch'
import { FormSubmitValues } from 'utils/formValidation'

import { NameDto } from '../../../api/Common/Types'
import {
  CreatePromoMaterialValues,
  PromoMaterialForm,
  UpdatePromoMaterialValues,
} from './PromoMaterialForm'

interface OuterProps {
  caLanguages: NameDto<string>[]
  referralMaterialId?: string
  promoMaterial: PromoMaterialDto
  sizes: NameDto[]
  onSubmit(
    values: FormSubmitValues<UpdatePromoMaterialValues | CreatePromoMaterialValues>
  ): Promise<void>
}

export const PromoMaterialEditForm: React.FC<OuterProps> = (props) => {
  const clientAreaApiClient = useApiClient(ClientAreaApiClient)
  const [isEdit, setEdit] = useState<boolean>(false)

  const { callback: fetchData } = useCallbackWithForceRefresh(() => {
    if (!props.referralMaterialId) return Promise.resolve(null)

    return clientAreaApiClient.getPromoMaterialsByPromoMaterialId(
      props.referralMaterialId,
      props.promoMaterial.id
    )
  }, [])
  const { data: promoMaterial, isLoading } = useFetchOne(fetchData)

  return (
    <Loading isLoading={isLoading} modalView>
      {promoMaterial && (
        <PromoMaterialForm
          {...props}
          promoMaterial={promoMaterial}
          isEdit={isEdit}
          setEdit={setEdit}
        />
      )}
    </Loading>
  )
}
